module.exports = __webpack_public_path__ + "static/media/PM83.b95f86ef.JPG";